module.exports = __webpack_public_path__ + "static/ssgdf-417d6f3630d220c7c88f01479d56aaca.png";